import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import '../../../styles/modalpopup.scss';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    zIndex: 100
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
  },
}))(MuiDialogActions);


export default function ModalpopupCalqulator(props) {
  return (
    <>
      <div>
        <Dialog maxWidth="lg" onClose={props.handleClickOpen} aria-labelledby="customized-dialog-title" open={props.open} className='Calculator_Popup'>
          <DialogTitle onClose={props.handleClickOpen}>
            {props.header}
          </DialogTitle>
          <DialogContent dividers className="modal_body">
            {props.contact}
          </DialogContent>
          <DialogActions style={{margin:'0px', padding:'0px', backgroundColor: '#E5E5E5'}}>
              {props.PopupFooter}
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}
